import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { GenericRichTextDirective } from '@core/jss-utils';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import {
  RichTextField,
  TextField,
  JssModule,
} from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-order-overview-budget-bill',
  templateUrl: './order-overview-budget-bill.component.html',
  styleUrls: [
    './order-overview-budget-bill.component.essent.scss',
    './order-overview-budget-bill.component.ed.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    AutomationIdDirective,
    AutomationIdDirective,
    RoundedCurrencyPipe,
    CSCaptureDirective,
    CommonUiFormsModule,
    JssModule,
    CommonUiUtilityComponentsModule,
    GenericRichTextDirective,
  ],
  providers: [RoundedCurrencyPipe],
})
export class OrderOverviewBudgetBillComponent {
  readonly beforeDiscountYearlyLabel = input<TextField>();
  readonly beforeDiscountYearlyAmount = input<number>(0);

  readonly cashbackLabel = input<TextField>();
  readonly cashbackAmount = input<number>(0);

  readonly yearlyLabel = input<string>();
  readonly yearlyAmount = input<number>(0);

  readonly monthlyAmountLabel = input.required<RichTextField>();
  readonly monthlyAmountTooltip = input<string>('');
  readonly monthlyAmount = input<number>(0);
  readonly monthlyAmountAdditionalLabel = input<string>('');

  readonly budgetBillLabel = input.required<RichTextField>();
  readonly budgetBillTooltip = input<string>('');
  readonly budgetBillAmount = input<number>(0);

  readonly promoCode = input<string>();

  readonly showCostsInHeader = input<boolean>(false);
  readonly hideAnnualCosts = input<boolean>(false);
  readonly termijnbedragVariantA = input<boolean | undefined>(false);
  readonly termijnbedragVariantB = input<boolean | undefined>(false);
  readonly costsWithDiscountLabel = input<string | undefined>('');

  readonly enableRemoveBBA = input<boolean | undefined>(false);
}
